// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as PervasivesU from "rescript/lib/es6/pervasivesU.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";
import * as SnippetOffsets$GameDataCore from "../SnippetOffsets.res.mjs";

function isHtmlElement(node) {
  return node.nodeType === 1;
}

function isTextNode(node) {
  return node.nodeType === 3;
}

function isBrElement(node) {
  if (node.nodeType === 1) {
    return node.tagName === "BR";
  } else {
    return false;
  }
}

function childNodeArray(node) {
  var list = node.childNodes;
  return Belt_Array.keepMap(Belt_Array.makeBy(list.length, (function (i) {
                    return Caml_option.nullable_to_opt(list.item(i));
                  })), (function (x) {
                return x;
              }));
}

function childTextLength(child) {
  if (isBrElement(child)) {
    return 1;
  }
  var content = child.textContent;
  if ((content == null) || content === "") {
    return 0;
  } else {
    return content.length;
  }
}

function datasetText(editor) {
  return DomEl$GameDataCore.data(editor, "text");
}

function datasetSnippetsJson(editor) {
  var json = editor.getAttribute("data-snippets");
  if ((json == null) || json === "") {
    return "null";
  } else {
    return json;
  }
}

function parseRows(json) {
  var parsed;
  try {
    parsed = JSON.parse(json);
  }
  catch (exn){
    parsed = null;
  }
  if (parsed == null) {
    return [];
  } else {
    return parsed.map(function (snippet) {
                var value = snippet.snippet_text;
                return {
                        needle: (value == null) ? "" : value,
                        start: Number(snippet.start_offset),
                        end: Number(snippet.end_offset)
                      };
              });
  }
}

function positionFromSelectionRange(range) {
  var rect = range.getClientRects().item(0);
  if (!(rect == null)) {
    return [
            rect.left + rect.width / 2.0,
            rect.top + rect.height / 2.0
          ];
  }
  
}

function findTextBoundary(root, globalOffset) {
  var walker = document.createTreeWalker(root, 4);
  var remaining = globalOffset;
  var result;
  var searching = true;
  while(searching) {
    var node = walker.nextNode();
    if (node == null) {
      searching = false;
    } else {
      var len = node.length;
      if (remaining <= len) {
        result = [
          node,
          remaining
        ];
        searching = false;
      } else {
        remaining = remaining - len | 0;
      }
    }
  };
  return result;
}

var markClasses = [
  "inline",
  "align-baseline",
  "p-0",
  "m-0",
  "bg-primary",
  "text-foreground"
];

function wrapSnippetRange(root, start, end_) {
  if (end_ <= start) {
    return ;
  }
  var match = findTextBoundary(root, start);
  var match$1 = findTextBoundary(root, end_);
  if (match === undefined) {
    return ;
  }
  if (match$1 === undefined) {
    return ;
  }
  var range = document.createRange();
  range.setStart(match[0], match[1]);
  range.setEnd(match$1[0], match$1[1]);
  var mark = document.createElement("mark");
  markClasses.forEach(function (name) {
        DomEl$GameDataCore.addClass(mark, name);
      });
  range.surroundContents(mark);
}

function lengthBefore(editor, target) {
  var length = {
    contents: 0
  };
  var reached = {
    contents: false
  };
  childNodeArray(editor).forEach(function (child) {
        if (!reached.contents) {
          if (child === target || child.contains(target)) {
            reached.contents = true;
          } else {
            length.contents = length.contents + childTextLength(child) | 0;
          }
          return ;
        }
        
      });
  return length.contents;
}

function endIsResolvable(editorNode, startNode, endNode) {
  if (startNode === endNode) {
    return true;
  } else if (endNode.nodeType === 1) {
    if (endNode === editorNode) {
      return true;
    } else {
      return isBrElement(endNode);
    }
  } else {
    return false;
  }
}

function selectionInsideEditor(editorNode, selection) {
  var anchor = selection.anchorNode;
  if (anchor == null) {
    return false;
  } else if (editorNode === anchor) {
    return true;
  } else {
    return editorNode.contains(anchor);
  }
}

function updateState(self) {
  var container = self.el;
  var element = container.querySelector("#snippet-editor-content");
  var editor = (element == null) ? PervasivesU.failwith("Snippet editor content not found") : element;
  var element$1 = container.querySelector("#snippet-editor-create-button");
  var createButton = (element$1 == null) ? PervasivesU.failwith("Snippet editor create button not found") : element$1;
  var rows = parseRows(datasetSnippetsJson(editor));
  self._editor = editor;
  self._createButton = createButton;
  self._text = DomEl$GameDataCore.data(editor, "text");
  self._rows = rows;
  self._ranges = rows.map(function (row) {
        return {
                start: row.start,
                end: row.end
              };
      });
}

function updateEditorContent(self) {
  var editor = self._editor;
  var text = self._text;
  editor.textContent = text;
  var reconciled = SnippetOffsets$GameDataCore.reconcile(text, self._rows);
  self._ranges = reconciled;
  SnippetOffsets$GameDataCore.renderOrder(reconciled).forEach(function (pair) {
        try {
          return wrapSnippetRange(editor, pair.start | 0, pair.end | 0);
        }
        catch (exn){
          return ;
        }
      });
}

function resetButtonPosition(button) {
  var declaration = button.style;
  declaration.position = "";
  declaration.top = "";
  declaration.left = "";
}

function hideCreateButton(button) {
  DomEl$GameDataCore.addClass(button, "hidden");
  resetButtonPosition(button);
}

function showCreateButton(button, left, top) {
  DomEl$GameDataCore.removeClass(button, "hidden");
  var declaration = button.style;
  declaration.position = "fixed";
  declaration.top = top.toString() + "px";
  declaration.left = left.toString() + "px";
}

function updateCreateButton(self) {
  var button = self._createButton;
  var editor = self._editor;
  var placement;
  if (self._isMouseDown) {
    placement = undefined;
  } else {
    var match = globalThis.getSelection();
    var match$1 = self._selection;
    if ((match == null) || (match$1 == null) || !selectionInsideEditor(editor, match) || match.rangeCount === 0) {
      placement = undefined;
    } else {
      var range = match.getRangeAt(0);
      var startNode = range.startContainer;
      var endNode = range.endContainer;
      if (endIsResolvable(editor, startNode, endNode)) {
        var offsetStart = lengthBefore(editor, startNode) + range.startOffset | 0;
        var offsetEnd = lengthBefore(editor, endNode) + range.endOffset | 0;
        placement = offsetStart === offsetEnd || SnippetOffsets$GameDataCore.overlapsAny(self._ranges, offsetStart, offsetEnd) ? undefined : positionFromSelectionRange(match.getRangeAt(0));
      } else {
        placement = undefined;
      }
    }
  }
  if (placement !== undefined) {
    return showCreateButton(button, placement[0], placement[1]);
  } else {
    return hideCreateButton(button);
  }
}

function persistSelection(self) {
  var editor = self._editor;
  var selection = globalThis.getSelection();
  if (selection == null) {
    self._selection = null;
    return ;
  }
  if (selectionInsideEditor(editor, selection)) {
    if (selection.rangeCount <= 0) {
      return ;
    }
    var range = selection.getRangeAt(0);
    var startNode = range.startContainer;
    var endNode = range.endContainer;
    if (endIsResolvable(editor, startNode, endNode)) {
      self._selection = {
        offsetStart: lengthBefore(editor, startNode) + range.startOffset | 0,
        offsetEnd: lengthBefore(editor, endNode) + range.endOffset | 0
      };
    }
    return updateCreateButton(self);
  }
  self._selection = null;
}

function clearSelection(self) {
  self._selection = null;
  updateCreateButton(self);
}

function selectPreviousSelection(self) {
  var match = self._selection;
  var match$1 = globalThis.getSelection();
  if (match == null) {
    return ;
  }
  if (match$1 == null) {
    return ;
  }
  var length = {
    contents: 0
  };
  var restored = {
    contents: false
  };
  childNodeArray(self._editor).forEach(function (child) {
        if (restored.contents) {
          return ;
        }
        if (isBrElement(child)) {
          length.contents = length.contents + 1 | 0;
          return ;
        }
        var content = child.textContent;
        if (content == null) {
          return ;
        }
        if (content === "") {
          return ;
        }
        var start = length.contents;
        var end_ = start + content.length | 0;
        if (!(start <= match.offsetStart && start <= match.offsetEnd && end_ >= match.offsetStart && end_ >= match.offsetEnd)) {
          length.contents = end_;
          return ;
        }
        var range = document.createRange();
        range.setStart(child, 0);
        range.setEnd(child, 1);
        match$1.removeAllRanges();
        match$1.addRange(range);
        restored.contents = true;
      });
}

function pushRoot(self) {
  var id = self.el.id;
  if (id === "") {
    return "#snippet-editor";
  } else {
    return "#" + id;
  }
}

function pushCreateSnippet(self, start, end_) {
  if (!SnippetOffsets$GameDataCore.overlapsAny(self._ranges, start, end_)) {
    self.pushEventTo(pushRoot(self), "create_snippet", {
          text: self._text.substring(start, end_),
          start_offset: start,
          end_offset: end_
        });
    return ;
  }
  
}

function createSelection(self) {
  var editor = self._editor;
  var selection = globalThis.getSelection();
  if (selection == null) {
    return ;
  }
  var match = selection.anchorNode;
  if (match == null) {
    return ;
  }
  if (selection.rangeCount <= 0) {
    return ;
  }
  var range = selection.getRangeAt(0);
  var startNode = range.startContainer;
  var endNode = range.endContainer;
  var start = range.startOffset;
  var end_ = range.endOffset;
  var content = startNode.textContent;
  if (content == null) {
    return ;
  }
  if (!(start !== end_ && startNode.nodeType === 3 && editor.contains(startNode))) {
    return ;
  }
  var offsetBoth = lengthBefore(editor, startNode);
  if (startNode === endNode) {
    return pushCreateSnippet(self, offsetBoth + start | 0, offsetBoth + end_ | 0);
  } else if (endNode.nodeType === 1 && (endNode === editor || isBrElement(endNode))) {
    return pushCreateSnippet(self, offsetBoth + start | 0, offsetBoth + content.length | 0);
  } else {
    return ;
  }
}

var safeMetaKeys = [
  "r",
  "t",
  "n",
  "o",
  "l",
  "w",
  "p",
  "c"
];

var navigationKeys = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Tab"
];

function preventDefaultAllowSafeKeys(self, $$event) {
  var key = $$event.key;
  if (!(safeMetaKeys.includes(key) && $$event.metaKey) && !navigationKeys.includes(key)) {
    $$event.preventDefault();
    if (key === "Enter" || key === "Return" || key === " ") {
      return createSelection(self);
    } else {
      return ;
    }
  }
  
}

function makeHandlers(self) {
  return {
          persistSelection: (function (param) {
              persistSelection(self);
            }),
          onMouseUpWindow: (function (param) {
              self._isMouseDown = false;
              updateCreateButton(self);
            }),
          onMouseDownEditor: (function (param) {
              self._isMouseDown = true;
            }),
          clearSelection: (function (param) {
              clearSelection(self);
            }),
          preventDefault: (function ($$event) {
              $$event.preventDefault();
            }),
          preventDefaultAllowSafeKeys: (function ($$event) {
              preventDefaultAllowSafeKeys(self, $$event);
            }),
          onEditorScroll: (function (param) {
              updateCreateButton(self);
            }),
          onMouseDownCreateButton: (function ($$event) {
              $$event.preventDefault();
            }),
          onMouseUpCreateButton: (function (param) {
              createSelection(self);
            })
        };
}

var suppressedEditorEvents = [
  "input",
  "focusout",
  "cut",
  "paste",
  "dragstart",
  "dragover",
  "dragend"
];

var windowEvents = [
  "mouseup",
  "touchend",
  "touchcancel",
  "contextmenu"
];

function addListeners(self) {
  var handlers = self._handlers;
  var editor = self._editor;
  var button = self._createButton;
  var active = {
    passive: false
  };
  document.addEventListener("selectionchange", handlers.persistSelection, active);
  windowEvents.forEach(function (name) {
        window.addEventListener(name, handlers.onMouseUpWindow, active);
      });
  editor.addEventListener("mousedown", handlers.onMouseDownEditor, active);
  editor.addEventListener("touchstart", handlers.onMouseDownEditor, active);
  editor.addEventListener("blur", handlers.clearSelection, active);
  suppressedEditorEvents.forEach(function (name) {
        editor.addEventListener(name, handlers.preventDefault, active);
      });
  editor.addEventListener("keydown", handlers.preventDefaultAllowSafeKeys, active);
  editor.addEventListener("keypress", handlers.preventDefaultAllowSafeKeys, active);
  editor.addEventListener("scroll", handlers.onEditorScroll, {
        capture: true,
        passive: false
      });
  button.addEventListener("mousedown", handlers.onMouseDownCreateButton, active);
  button.addEventListener("mouseup", handlers.onMouseUpCreateButton, active);
}

function removeListeners(self) {
  var handlers = self._handlers;
  var editor = self._editor;
  var button = self._createButton;
  document.removeEventListener("selectionchange", handlers.persistSelection);
  windowEvents.forEach(function (name) {
        window.removeEventListener(name, handlers.onMouseUpWindow);
      });
  editor.removeEventListener("mousedown", handlers.onMouseDownEditor);
  editor.removeEventListener("touchstart", handlers.onMouseDownEditor);
  editor.removeEventListener("blur", handlers.clearSelection);
  suppressedEditorEvents.forEach(function (name) {
        editor.removeEventListener(name, handlers.preventDefault);
      });
  editor.removeEventListener("keydown", handlers.preventDefaultAllowSafeKeys);
  editor.removeEventListener("keypress", handlers.preventDefaultAllowSafeKeys);
  editor.removeEventListener("scroll", handlers.onEditorScroll, {
        capture: true
      });
  button.removeEventListener("mousedown", handlers.onMouseDownCreateButton);
  button.removeEventListener("mouseup", handlers.onMouseUpCreateButton);
}

function mounted() {
  var self = this ;
  self._isMouseDown = false;
  self._selection = null;
  self._handlers = makeHandlers(self);
  updateState(self);
  updateEditorContent(self);
  var editor = self._editor;
  self._lastAppliedText = DomEl$GameDataCore.data(editor, "text");
  self._lastAppliedSnippetsJson = datasetSnippetsJson(editor);
  addListeners(self);
}

function updated() {
  var self = this ;
  removeListeners(self);
  updateState(self);
  var editor = self._editor;
  var newText = DomEl$GameDataCore.data(editor, "text");
  var newJson = datasetSnippetsJson(editor);
  if (newText !== self._lastAppliedText || newJson !== self._lastAppliedSnippetsJson) {
    updateEditorContent(self);
    selectPreviousSelection(self);
    self._lastAppliedText = newText;
    self._lastAppliedSnippetsJson = newJson;
  }
  addListeners(self);
  updateCreateButton(self);
}

function destroyed() {
  var self = this ;
  removeListeners(self);
}

var snippetEditor = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var elementNodeType = 1;

var textNodeType = 3;

var showText = 4;

export {
  elementNodeType ,
  textNodeType ,
  showText ,
  isHtmlElement ,
  isTextNode ,
  isBrElement ,
  childNodeArray ,
  childTextLength ,
  datasetText ,
  datasetSnippetsJson ,
  parseRows ,
  positionFromSelectionRange ,
  findTextBoundary ,
  markClasses ,
  wrapSnippetRange ,
  lengthBefore ,
  endIsResolvable ,
  selectionInsideEditor ,
  updateState ,
  updateEditorContent ,
  resetButtonPosition ,
  hideCreateButton ,
  showCreateButton ,
  updateCreateButton ,
  persistSelection ,
  clearSelection ,
  selectPreviousSelection ,
  pushRoot ,
  pushCreateSnippet ,
  createSelection ,
  safeMetaKeys ,
  navigationKeys ,
  preventDefaultAllowSafeKeys ,
  makeHandlers ,
  suppressedEditorEvents ,
  windowEvents ,
  addListeners ,
  removeListeners ,
  mounted ,
  updated ,
  destroyed ,
  snippetEditor ,
}
/* mounted Not a pure module */
